"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClipboardExtension = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _core = require("@tiptap/core");

function handler(e) {
  e.preventDefault();
  return;
}

function collectDisabledEvents(options) {
  return Object.keys(options).filter(function (o) {
    return options[o] === false;
  });
}

function attachClipboardEvents(domElement, events) {
  events.forEach(function (event) {
    return domElement.addEventListener(event, handler, true);
  });
}

function deattachClipboardEvents(domElement, events) {
  events.forEach(function (event) {
    return domElement.removeEventListener(event, handler, true);
  });
}

var cleanClipboardHTML = function cleanClipboardHTML(content) {
  return content.replace(/<meta.*?>(.*?<\/meta>)?/gi, '');
};

var ClipboardExtension = _core.Extension.create({
  name: 'clipboard',
  onCreate: function onCreate() {
    var events = collectDisabledEvents(this.options);
    attachClipboardEvents(this.editor.view.dom, events);
  },
  onDestroy: function onDestroy() {
    var events = collectDisabledEvents(this.options);
    deattachClipboardEvents(this.editor.view.dom, events);
  },
  addCommands: function addCommands() {
    var editor = this.editor;

    var paste = function paste() {
      return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var content, contentFromClipboard, _contentFromClipboard, clipboardItem, blobWithHTML, blobWithText, _blobWithText;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return window.navigator.clipboard.read();

              case 2:
                contentFromClipboard = _context.sent;

                if (!(contentFromClipboard && contentFromClipboard.length > 0)) {
                  _context.next = 31;
                  break;
                }

                _contentFromClipboard = (0, _slicedToArray2.default)(contentFromClipboard, 1), clipboardItem = _contentFromClipboard[0];

                if (!clipboardItem.types.includes('text/html')) {
                  _context.next = 23;
                  break;
                }

                _context.next = 8;
                return clipboardItem.getType('text/html');

              case 8:
                blobWithHTML = _context.sent;
                _context.t0 = cleanClipboardHTML;
                _context.next = 12;
                return blobWithHTML.text();

              case 12:
                _context.t1 = _context.sent;
                content = (0, _context.t0)(_context.t1);

                if (!content.includes('<span style="caret-color: rgb(0, 0, 0)')) {
                  _context.next = 21;
                  break;
                }

                _context.next = 17;
                return clipboardItem.getType('text/plain');

              case 17:
                blobWithText = _context.sent;
                _context.next = 20;
                return blobWithText.text();

              case 20:
                content = _context.sent;

              case 21:
                _context.next = 30;
                break;

              case 23:
                if (!clipboardItem.types.includes('text/plain')) {
                  _context.next = 30;
                  break;
                }

                _context.next = 26;
                return clipboardItem.getType('text/plain');

              case 26:
                _blobWithText = _context.sent;
                _context.next = 29;
                return _blobWithText.text();

              case 29:
                content = _context.sent;

              case 30:
                if (content) {
                  editor.chain().focus().insertContent(content).run();
                }

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    var copy = function copy() {
      return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var currentDocument, selection, container, i, len;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Global document object inside of iframe
                currentDocument = editor.view.dom.ownerDocument;
                selection = currentDocument.getSelection();

                if (selection && selection.rangeCount && !selection.isCollapsed) {
                  container = document.createElement('div');

                  for (i = 0, len = selection.rangeCount; i < len; ++i) {
                    container.appendChild(selection.getRangeAt(i).cloneContents());
                  } // Copying the content in two mime types


                  navigator.clipboard.write([new ClipboardItem({
                    'text/html': new Blob([container.innerHTML], {
                      type: 'text/html'
                    }),
                    'text/plain': new Blob([container.innerText], {
                      type: 'text/plain'
                    })
                  })]);
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };

    return {
      copy: copy,
      paste: paste
    };
  }
});

exports.ClipboardExtension = ClipboardExtension;